import { render, staticRenderFns } from "./TransportCostsList.vue?vue&type=template&id=41c4c9fc&"
import script from "./TransportCostsList.vue?vue&type=script&lang=ts&"
export * from "./TransportCostsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports